import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedReorder202601: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_reorder_202601",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-01-01",
  endDate: "2026-01-31",
  impressions: 8511,
  clicks: 113,
  adsSpendDollars: 334,
  budgetDollars: 600,
  salesDollars: 2218,
  bestEstimateRoas: 6.64,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.56,
  reorderConversions: 8,
  dataAvailableAtDate: "2026-02-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
